import GroupManager from "../components/GroupManager";

export default function GroupPage() {
  return (
    <div className="relative top-[20vh] max-sm:top-[10vh] p-2 h-[80vh] ">
      <GroupManager />
    </div>
  );
}
